import React from "react";

// Click-to-edit field used in the application details modal.
// Fully controlled: the parent owns which field is editing and its draft value.
const EditableField = ({
    label,
    type = "text",
    options = null,
    currentValue,
    isEditing,
    editValue,
    onEditValueChange,
    onStartEdit,
    onSave,
    onCancel,
    isSaving,
    hasChanged,
}) => {
    if (isEditing) {
        return (
            <div className="detail-field editing">
                <strong>{label}:</strong>
                <div className="edit-input-wrapper">
                    {options ? (
                        <select
                            value={editValue}
                            onChange={(e) => onEditValueChange(e.target.value)}
                            autoFocus
                        >
                            <option value="">Select...</option>
                            {options.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    ) : type === "textarea" ? (
                        <textarea
                            value={editValue}
                            onChange={(e) => onEditValueChange(e.target.value)}
                            rows="3"
                            autoFocus
                        />
                    ) : (
                        <input
                            type={type}
                            value={editValue}
                            onChange={(e) => onEditValueChange(e.target.value)}
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && type !== "textarea") onSave();
                                if (e.key === "Escape") onCancel();
                            }}
                        />
                    )}
                    <div className="edit-actions">
                        {hasChanged && (
                            <button
                                className="save-field-btn"
                                onClick={onSave}
                                disabled={isSaving}
                                title="Save"
                            >
                                {isSaving ? "..." : "✓"}
                            </button>
                        )}
                        <button
                            className="cancel-field-btn"
                            onClick={onCancel}
                            disabled={isSaving}
                            title="Cancel"
                        >
                            ✕
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className="detail-field clickable"
            onClick={onStartEdit}
            title="Click to edit"
        >
            <strong>{label}:</strong>
            <span className="editable-value">{currentValue || "N/A"}</span>
            <span className="edit-hint">✏️</span>
        </div>
    );
};

export default EditableField;
